module.exports = __webpack_public_path__ + "static/media/icon-team-personality-low.d7f7dd98.svg";